// extracted by mini-css-extract-plugin
export default {"thememodal":"ThemeModal_thememodal__TW0yl","modal-content":"ThemeModal_modal-content__EH4sv","header":"ThemeModal_header__tKbEN","headingmodal":"ThemeModal_headingmodal__FPzHL"};